module.exports = __webpack_public_path__ + "img/icon_save.63527b63.svg";